<template>
  <admin-table
    ref="table"
    :api-builder="apiBuilder"
    :columns="columns"
    :row-actions="['edit', 'delete']"
    :bulk-actions="[]"
    :search-fields="null"
    :on-edit-item="editing"
  />
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'

export default {
  name: 'Table',

  components: {
    AdminTable,
  },

  props: {
    apiBuilder: {
      type: Function,
      required: true,
    },
  },

  computed: {
    columns() {
      return [
        {
          key: 'zone_a.name',
          label: this.$t('vehicles.attributes.pricing.zone_a.label'),
        },
        {
          key: 'zone_b.name',
          label: this.$t('vehicles.attributes.pricing.zone_b.label'),
        },
        {
          key: 'availability_label',
          label: this.$t('vehicles.availability'),
        },
      ]
    },
  },

  methods: {
    editing(item) {
      this.$emit('edit', item)
    },
    refresh() {
      this.$refs.table.refresh()
    },
  },
}
</script>
